(function ($) {
    $.extend($.layoutManager.messages, {
        states: {
            empty: "Cet emplacement est vide. Cliquez pour y ajouter une carte.",
            checked: "Le bloc est complet. La saisie de ses données est complète et valide.",
            incomplete: "Le bloc est incomplet. Des données obligatoires sont manquantes.",
            warning: "L'outil d'édition ne reconnait pas le type de bloc utilisé. Veuillez contacter votre Webmaster.",
            error: "Une erreur est survenue lors du traitement de ce bloc. Veuillez contacter votre Webmaster."
        },
        actions: {
            edit: "Éditer",
            empty: "Vider",
            confirm: {
                empty: "Vous avez demandé la suppression de la carte. Êtes-vous sur de vouloir continuer ?"
            }
        },
        popin: {
            title: "Édition de l'emplacement",
            save: "Enregistrer",
            cancel: "Annuler"
        }
    });
})(jQuery);